module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('bread-crumb', {
    attrs: {
      "routeName": 'Contact'
    }
  }), _vm._v(" "), (_vm.isLoading) ? _c('loading') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "columns is-marginless is-paddingless is-gapless"
  }, [_c('div', {
    staticClass: "column is-7 m-b-10",
    class: {
      'm-r-10': _vm.$mq.resize && _vm.$mq.above(_vm.$mv.tablet)
    }
  }, [_c('card', {
    attrs: {
      "red": true,
      "background": _vm.egypt_image,
      "isButtonHidden": true,
      "html": true,
      "email": _vm.egypt_email,
      "subtitle": _vm.egypt,
      "title": "EGYPT",
      "height": "70vh"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-5 m-b-10"
  }, [_c('card', {
    attrs: {
      "red": true,
      "background": _vm.UAE_image,
      "isButtonHidden": true,
      "html": true,
      "email": _vm.UAE_email,
      "subtitle": _vm.UAE,
      "title": "UAE",
      "height": "70vh"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "columns is-marginless is-paddingless is-gapless"
  }, [_c('div', {
    staticClass: "column is-5 m-b-10",
    class: {
      'm-r-10': _vm.$mq.resize && _vm.$mq.above(_vm.$mv.tablet)
    }
  }, [_c('card', {
    attrs: {
      "red": true,
      "background": _vm.USA_image,
      "isButtonHidden": true,
      "html": true,
      "email": _vm.USA_email,
      "subtitle": _vm.USA,
      "title": "USA",
      "height": "70vh"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-7 m-b-10"
  }, [_c('card', {
    attrs: {
      "red": true,
      "background": _vm.switzerland_image,
      "isButtonHidden": true,
      "html": true,
      "email": _vm.switzerland_email,
      "subtitle": _vm.switzerland,
      "title": "SWITZERLAND",
      "height": "70vh"
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77fe087e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layout/pages/contact.vue
// module id = 1146
// module chunks = 1